module.exports = "/images/accounts.svg?59eb86b76fb9b1376d26f5a0e21609f1";